import React, { JSX, useEffect } from 'react'
import { useGLTF, useTexture, useAnimations } from '@react-three/drei'
import * as THREE from 'three'

type CaseModelProps = JSX.IntrinsicElements['group'] & {
  textureUrl: string
  playLid: boolean
}

const CaseModel: React.FC<CaseModelProps> = ({ textureUrl, playLid, ...props }) => {
  const { scene, animations } = useGLTF('/models/case.glb')
  const texture = useTexture(textureUrl)
  const caseTexture = useTexture('./cases/texture.png')
  const { actions } = useAnimations(animations, scene)

  useEffect(() => {

    scene.traverse((child) => {
      if ((child as THREE.Mesh).isMesh) {
        texture.wrapS = texture.wrapT = THREE.RepeatWrapping
        const mesh = child as THREE.Mesh
        console.log(mesh.name)
        if (mesh.name === 'Основа010') {
          mesh.geometry.computeBoundingBox()
          const bbox = mesh.geometry.boundingBox!
          const size = new THREE.Vector3()
          bbox.getSize(size)

          const positions = mesh.geometry.attributes.position
          const uv: number[] = []

          for (let i = 0; i < positions.count; i++) {
            const x = positions.getX(i)
            const y = positions.getY(i)

            uv.push((x - bbox.min.x) / size.x)
            uv.push((y - bbox.min.y) / size.y)
          }

          mesh.geometry.setAttribute('uv', new THREE.Float32BufferAttribute(uv, 2))
          mesh.material = new THREE.MeshStandardMaterial({ map: texture })
          mesh.material.needsUpdate = true
        } else {
          mesh.material = new THREE.MeshStandardMaterial({ map: caseTexture })
          mesh.material.needsUpdate = true
          // mesh.material.color.offsetHSL(0, 0, 0.07)
        }
        mesh.material.needsUpdate = true;
      }
    })
  }, [scene, texture, actions])

  useEffect(() => {
    const action = actions?.['крышкаAction.001'];
    if (playLid && action) {
      action.reset();
      action.setLoop(THREE.LoopOnce, 1); // проиграть один раз
      action.clampWhenFinished = true; // зафиксировать последний кадр
      console.log(action.clampWhenFinished)
      action.play();
      setTimeout(() => {
        action.paused = true;
      }, 780)

      const onFinished = (e: any) => {
        if (e.action === action) {
      action.paused = true;

          action.stop();
          // можно добавить другие действия по завершении
        }
      };

      action.getMixer().addEventListener('finished', onFinished);

      return () => {
        action.getMixer().removeEventListener('finished', onFinished);
        action.stop();
      };
    }
  }, [playLid, actions]);


  return <primitive object={scene} {...props} />
}

useGLTF.preload('/models/case.glb')

export default CaseModel
